module.exports = "/../../dist/frontend/images/agency-pin-some.png?175ce63e406ea812b44bbfcb1fbb2f0d";